import {
  CarouselType,
  TOneLineDeatil,
  faqContentType,
  nextProgressCarouselType,
} from '@utils/types';

//const chopChef = 'https://d222i9ppxs2fqe.cloudfront.net/chopChef_opt.gif';
const miliJuli = 'https://d222i9ppxs2fqe.cloudfront.net/miliJuli.png';
const groupingBagBalanced =
  'https://d222i9ppxs2fqe.cloudfront.net/groupingBagBalanced.png';
const gingerChilli = 'https://d222i9ppxs2fqe.cloudfront.net/gingerChilli.png';
const bitmap = 'https://d222i9ppxs2fqe.cloudfront.net/bitmap.png';
const reviewPic = 'https://d222i9ppxs2fqe.cloudfront.net/reviewPic.png';
const orderFlowChef = 'https://d222i9ppxs2fqe.cloudfront.net/orderFlowChef.png';
const stainlessSteelPot =
  'https://d222i9ppxs2fqe.cloudfront.net/steel_pot_with_steam.png';

const carouselContent: CarouselType[] = [
  {
    id: '1',
    icon: gingerChilli,
    alt: 'gingerChilli',
    title: 'Authentic Indian tastes',
    subtitle:
      'These are authentic Indian dishes prepared by expert chefs using native all-natural ingredients.',
    priority: true,
  },
  {
    id: '2',
    icon: miliJuli,
    alt: 'miliJuli',
    title: 'Clean Food, Always',
    subtitle:
      'Freeze drying our meals ensures great flavor, no nutrition loss, and a long shelf life, with no additives.',
  },
  {
    id: '3',
    icon: stainlessSteelPot,
    alt: 'stainlessSteelPot',
    title: 'Ready in 5 Minutes',
    subtitle:
      'This is cooking made easy. Just add hot water, wait a few minutes, and your favorite meal is ready to eat!',
  },
  {
    id: '4',
    icon: groupingBagBalanced,
    alt: 'groupingBagBalanced',
    width: 350,
    title: 'Delivered to your door',
    subtitle:
      'No more waiting in lines at the store. Everything is delivered for free right to your doorstep.',
  },
];

const faqContent: faqContentType[] = [
  {
    id: '1',
    title: 'What are these meal kits?',
    ans: 'These are authentic Indian ready-to-cook meal kits that take just about 5 minutes of your time to prepare a meal out of. Most dishes are prepared by emptying the contents into a bowl and just adding hot water.',
  },
  {
    id: '2',
    title: 'Am I locked into a subscription?',
    ans: 'Not at all. You can even cancel your subscription right after your first order if you wish to. You have full control, always!',
  },
  {
    id: '3',
    title: 'Can I change my meals for future orders?',
    ans: 'Yes, you can change your meals anytime by logging into your account',
  },
  {
    id: '4',
    title: 'How long does it take to deliver?',
    ans: 'Your meals will be delivered to you within 3-5 business days by UPS or FedEx.',
  },
  {
    id: '5',
    title:
      'What is the shelf life of the meal kits and how does one store them?',
    ans: 'Our meal kits stay fresh for 4 to 20 weeks from the time you receive them (Best Before dates will be listed on each pack). Since our meals are all-natural with zero preservatives they will have a shorter shelf life than other heavily processed foods. All the meal kits can be stored at room temperature.',
  },
  {
    id: '6',
    title: 'Can I get the nutrition information and ingredients for each dish?',
    ans: 'Yes, once you select a plan, you can view all the dishes on our menu. Click on the image of any dish to get more information such as sides, ingredients, nutrition facts and more',
  },

  {
    id: '7',
    title: 'How does The Cumin Club ensure quality?',
    ans: 'Quality is our highest priority! From detailed on-boarding and regular kitchen visits, to taking each and every customer complaint seriously, our quality control team ensures that your meals meet a high quality standard.',
  },
  // {
  //   id: '8',
  //   title: 'How will I receive my meals?',
  //   ans: 'Your meals will be delivered directly to your delivery address by UPS/FedEx.',
  // },
  // {
  //   id: '9',
  //   title: 'Who prepares my meals?',
  //   ans: 'Your meals will be curated by expert chefs across India. Our partners are experts at dry-and-fly (freeze drying process).',
  // },
  // {
  //   id: '10',
  //   title: 'Can I see your menu first?',
  //   ans: 'Sure - you can view our menu <a href="https://thecuminclub.com/our-menu">here</a>',
  // },
];

const nextProgresscarouselContent: nextProgressCarouselType[] = [
  {
    id: '1',
    icon: reviewPic,
    alt: 'reviewPic',
    title:
      '“I couldn’t find these flavors anywhere! These meals taste just like home!”',
    author: '- Pratiksha P',
    username: '@pratiksha.bakes',
  },
  {
    id: '2',
    icon: orderFlowChef,
    alt: 'orderFlowChef',
    title:
      '“I couldn’t find these flavors anywhere! These meals taste just like home!”',
    author: '- Pratiksha P',
    username: '@pratiksha.bakes',
  },
  {
    id: '3',
    icon: bitmap,
    alt: 'bitmap',
    title:
      '“I couldn’t find these flavors anywhere! These meals taste just like home!”',
    author: '- Pratiksha P',
    username: '@pratiksha.bakes',
  },
];

const OrderStepOneLineDetailContent: TOneLineDeatil[] = [
  { id: 1, text: 'Shipping is always free' },
  { id: 2, text: 'Pause or cancel anytime' },
  { id: 3, text: 'Not satisfied? First box is on us!' },
];

export {
  carouselContent,
  faqContent,
  nextProgresscarouselContent,
  OrderStepOneLineDetailContent,
};
